module.exports = __webpack_public_path__ + "static/media/banner-mobile-npay@3x.1c888ef1.png";